import { Fragment } from "@wordpress/element";
import { Button, PanelBody, PanelRow } from '@wordpress/components';
import { InspectorControls, RichText, MediaUpload } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

const ALLOWED_MEDIA_TYPES = [ 'image' ];

const attributes = {
  imgUrl: {
    type: 'string',
    default: 'https://dummyimage.com/1920x720/cadae2/49585f.png&text=Placeholder'
  },
  imgUrlMobile: {
    type: 'string',
  },
  imgAlt: {
    type: 'string'
  },
  imgAltMobile: {
    type: 'string'
  },
  attribution: {
    type: 'string'
  }
};

const HeaderImage = {
  title: __('Header Image'),
  description: __('Header image block for the ABS theme'),
  icon: 'format-image',
  attributes: attributes,
  supports: {
    customClassName: false,
  },
  edit({ className, attributes, setAttributes }) {
    const { imgUrl, imgAlt, imgUrlMobile, attribution } = attributes;
    const ALLOWED_MEDIA_TYPES = [ 'image' ];

    const image = (
      <img
        src={ imgUrl }
        alt={ imgAlt }
      />
    );

    function selectDesktopImage(value) {
      setAttributes({
        imgUrl: value.media_details.sizes.full_width.source_url,
        imgAlt: value.alt_text,
      })
    }

    function selectMobileImage(value) {
      setAttributes({
        imgUrlMobile: value.media_details.sizes.abs_header_md.source_url,
        imgAltMobile: value.alt_text,
      })
    }

    return (
      <Fragment>
        <div className={className}>
          <div className={"container-fluid"}>
            <div className={"row"}>
              <div className={"col"}>
                { image }
              </div>
            </div>
            <div className={"row"}>
              <div className={"col attribution"}>
                <RichText
                  tagName="p"
                  value={ attribution }
                  placeholder={ __('Insert attribution information') }
                  allowedFormats={['core/link']}
                  onChange={nextAttribution => setAttributes({ attribution: nextAttribution })}
                />
              </div>
            </div>
          </div>
        </div>
        <InspectorControls>
          <PanelBody title={ __('Desktop') }>
            <PanelRow>
              {imgUrl && (
                <img src={ imgUrl } />
              )}
            </PanelRow>
            <PanelRow>
              <MediaUpload
                allowedTypes={ ALLOWED_MEDIA_TYPES }
                onSelect={ selectDesktopImage }
                render={ ({open}) => {
                  return (
                    <Button
                      variant={'primary'}
                      label={ __('Set image') }
                      onClick={ open }>{ (imgUrl) ? __('Replace image') : __('Set image') }</Button>)
                }}
              />
            </PanelRow>
          </PanelBody>
        </InspectorControls>
        <InspectorControls>
          <PanelBody title={ __('Mobile') }>
            <PanelRow>
              {imgUrlMobile && (
                <img src={ imgUrlMobile } />
              )}
            </PanelRow>
            <PanelRow>
              <MediaUpload
                allowedTypes={ ALLOWED_MEDIA_TYPES }
                onSelect={ selectMobileImage }
                render={ ({open}) => {
                  return (
                    <Button
                      variant={'primary'}
                      label={ __('Set image') }
                      onClick={ open }>{(imgUrlMobile) ? __('Replace image') : __('Set image') }</Button>)
                }}
              />
            </PanelRow>
          </PanelBody>
        </InspectorControls>
      </Fragment>
    );
  },

  save({ className, attributes }) {
    const { imgUrl, imgAlt, imgUrlMobile, attribution } = attributes;

    return (
      <div className={className}>
        <div className={"container-fluid"}>
          <div className={"row"}>
            <div className={"col px-0"}>
              <picture>
                {imgUrlMobile && (
                  <source media="(max-width: 992px)"
                          srcSet={ imgUrlMobile } />
                  )}
                  <img
                    src={ imgUrl }
                    alt={ imgAlt }
                    className={'img-fluid'}
                  />
              </picture>
            </div>
          </div>
          {attribution && (
            <div className={"row"}>
              <div className={"col attribution"}>
                <RichText.Content tagName="p" value={ attribution } />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  },

  deprecated: [
    {
      attributes,
      save({ className, attributes }) {
        const { imgAlt, attribution } = attributes;

        return (
          <div className={className}>
            <div className={"container-fluid"}>
              <div className={"row"}>
                <div className={"col px-0"}>
                  <img src={attributes.imgUrl} className={"img-fluid"} alt={ imgAlt } />
                </div>
              </div>
              {attribution && (
                <div className={"row"}>
                  <div className={"col attribution"}>
                    <RichText.Content tagName="p" value={ attribution } />
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      },
    }

  ],

};

export default HeaderImage;
